import { ObservableService } from "../services/ObservableService";

const initialState = {
  medicalSpecialties: [],
  nonMedicalSpecialties: [],
  procedureOutpatient: [],
  examOutpatient: [],
  urgencyAndEmergency: [],
  hospital: [],
  hospitalBeds: [],
  hospitalizationDays: [],
};

export const attributeStore = ObservableService.persistentObservable(
  "attributeStore",
  () => initialState,
  3600
);

export function attributeClear() {
  attributeStore.medicalSpecialties = [];
  attributeStore.nonMedicalSpecialties = [];
  attributeStore.procedureOutpatient = [];
  attributeStore.examOutpatient = [];
  attributeStore.urgencyAndEmergency = [];
  attributeStore.hospital = [];
  attributeStore.hospitalBeds = [];
  attributeStore.hospitalizationDays = [];
}
